// Single source for contact details and social profiles. These were previously
// duplicated across Header/Menu/Footer/Consultation, and the header and footer
// had drifted onto two different Instagram accounts.

// Prices in programs.json are plain digit strings. Group them the Indian way
// (en-IN gives 1,000 / 12,500 and 1,00,000 rather than 100,000).
export function formatPrice(value) {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount.toLocaleString('en-IN') : value;
}

export const PHONE = '+916287091071';
export const PHONE_DISPLAY = '+91-6287091071';
export const EMAIL = 'garima@nutrism.in';

// wa.me wants the number without '+' or separators.
export const WHATSAPP_NUMBER = PHONE.replace(/\D/g, '');

export const CONSULTATION_FEE = 1000;

export function whatsappLink(message) {
    const base = `https://wa.me/${WHATSAPP_NUMBER}`;
    return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

export function mailtoLink(subject, body) {
    return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export const SOCIAL_LINKS = [
    {
        key: 'facebook',
        href: 'https://www.facebook.com/profile.php?id=100072036812517',
        icon: 'fa-facebook',
        label: 'Facebook',
    },
    {
        key: 'instagram',
        href: 'https://www.instagram.com/gari.rathore/',
        icon: 'fa-instagram',
        label: 'Instagram',
    },
    {
        key: 'linkedin',
        href: 'https://www.linkedin.com/in/garima-singh-rathore-312b7a108/',
        icon: 'fa-linkedin',
        label: 'LinkedIn',
    },
];
